var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"col-12 col-md-4 read-only"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.label))]),_c('div',{staticClass:"value",class:{ bold: item.bold }},[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }